import Content from "uxp-documentation/src/pages/uxp-api/reference-css/Selectors/Descendant combinator";
import * as React from 'react';
export default {
  Content,
  React
};